import FormWizardTwoContainer from "../../Componant/FormLayout/FormWizardTwo";

const FormWizardTwo = () => {
  return (
    <div className="page-body">
      <FormWizardTwoContainer />
    </div>
  );
};

export default FormWizardTwo;
